const programExternalInfoActionTypes = {
  GET_PROGRAM_EXTERNAL_INFO_START: 'GET_PROGRAM_EXTERNAL_INFO_START',
  GET_PROGRAM_EXTERNAL_INFO_SUCCESS: 'GET_PROGRAM_EXTERNAL_INFO_SUCCESS',
  GET_PROGRAM_EXTERNAL_INFO_FAILURE: 'GET_PROGRAM_EXTERNAL_INFO_FAILURE',
  GET_PROGRAM_EXTERNAL_INFO_FINISHED: 'GET_PROGRAM_EXTERNAL_INFO_FINISHED'
};

export default programExternalInfoActionTypes;
